export const FORMS_ENGINE_CASETABLE_FORM_VIEW_RESOURCE = {
  key: 'FORMS_ENGINE_CASETABLE_FORM_VIEW_RESOURCE'
};

export const FORMS_ENGINE_DOSSIER_REQUEST_FORM_VIEW_RESOURCE = {
  key: 'FORMS_ENGINE_DOSSIER_REQUEST_FORM_VIEW_RESOURCE'
};
